import Home from "./Home/Home";
import React from "react";

function App() {
  return (
    <div>
      <Home />
    </div>
  );
}

export default App;
